<template>
	<div style="padding: 20px 20px 20px 0;">
		<object type='application/x-vlc-plugin' class="vlc-item" id='vlc' events='True'
			pluginspage="http://www.videolan.org" codebase="http://comic.sjtu.edu.cn/vlc/cab/axvlc.cab" width="576"
			height="324" v-for="item in 8">
			<param name='mrl'
				:value="`rtsp://admin:bd123456@192.168.0.100:554/Streaming/Channels/${item}01?transportmode=multicast`" />
			<param name='volume' value='50' />
			<param name='autoplay' value='true' />
			<param name='loop' value='false' />
			<param name="fullscreen" value="true" />
			<param name='controls' value='false' />
		</object>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {

		},
		created() {

		}
	}
</script>

<style scoped="scoped">
</style>
